import { render, staticRenderFns } from "./SelectLayerSubType.vue?vue&type=template&id=15247f2b"
import script from "./SelectLayerSubType.vue?vue&type=script&lang=js"
export * from "./SelectLayerSubType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports